import { render, staticRenderFns } from "./SignatureTemplate4.vue?vue&type=template&id=22f5d4e7"
import script from "./SignatureTemplate4.vue?vue&type=script&lang=js"
export * from "./SignatureTemplate4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports